import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="htmldialogelement" id="htmldialogelement"></a>
    <h1 {...{
      "id": "windowhtmldialogelement"
    }}>{`window.HTMLDialogElement`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement`}</a>{`  `}</p>
    <a name="htmldialogelement-open" id="htmldialogelement-open"></a>
    <h2 {...{
      "id": "open--boolean"
    }}>{`open : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="htmldialogelement-isminimized" id="htmldialogelement-isminimized"></a>
    <h2 {...{
      "id": "isminimized--boolean"
    }}>{`isMinimized : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="htmldialogelement-returnvalue" id="htmldialogelement-returnvalue"></a>
    <h2 {...{
      "id": "returnvalue--"
    }}>{`returnValue : `}<inlineCode parentName="h2">{`*`}</inlineCode></h2>
    <a name="htmldialogelement-rejection-reason-not-allowed" id="htmldialogelement-rejection-reason-not-allowed"></a>
    <h2 {...{
      "id": "rejection_reason_not_allowed"
    }}>{`REJECTION`}{`_`}{`REASON`}{`_`}{`NOT`}{`_`}{`ALLOWED`}</h2>
    <p>{`When the promise returned from openDialog() is rejected, error.code can be equal to this value,
which means that the application does not allow showing dialogs (e.g. only one dialog is allowed).`}</p>
    <a name="htmldialogelement-rejection-reason-detached" id="htmldialogelement-rejection-reason-detached"></a>
    <h2 {...{
      "id": "rejection_reason_detached"
    }}>{`REJECTION`}{`_`}{`REASON`}{`_`}{`DETACHED`}</h2>
    <p>{`When the promise returned from openDialog() is rejected, error.code can be equal to this value,
which means that the node has been detached from DOM tree.`}</p>
    <a name="htmlelement-dataset" id="htmlelement-dataset"></a>
    <h2 {...{
      "id": "dataset"
    }}>{`dataset`}</h2>
    <p>{`Access to all the custom data attributes (data-*) set.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset`}</a>{`  `}</p>
    <a name="htmlelement-innertext" id="htmlelement-innertext"></a>
    <h2 {...{
      "id": "innertext--string"
    }}>{`innerText : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="htmlelement-lang" id="htmlelement-lang"></a>
    <h2 {...{
      "id": "lang--string"
    }}>{`lang : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="element-nodename" id="element-nodename"></a>
    <h2 {...{
      "id": "nodename--string"
    }}>{`nodeName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-localname" id="element-localname"></a>
    <h2 {...{
      "id": "localname--string"
    }}>{`localName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-tagname" id="element-tagname"></a>
    <h2 {...{
      "id": "tagname--string"
    }}>{`tagName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-nodetype" id="element-nodetype"></a>
    <h2 {...{
      "id": "nodetype--number"
    }}>{`nodeType : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-namespaceuri" id="element-namespaceuri"></a>
    <h2 {...{
      "id": "namespaceuri--string"
    }}>{`namespaceURI : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-id" id="element-id"></a>
    <h2 {...{
      "id": "id--string"
    }}>{`id : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="element-tabindex" id="element-tabindex"></a>
    <h2 {...{
      "id": "tabindex--number"
    }}>{`tabIndex : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <a name="element-classname" id="element-classname"></a>
    <h2 {...{
      "id": "classname--string"
    }}>{`className : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="element-attributes" id="element-attributes"></a>
    <h2 {...{
      "id": "attributes--namednodemap"
    }}>{`attributes : `}<inlineCode parentName="h2">{`NamedNodeMap`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-style" id="element-style"></a>
    <h2 {...{
      "id": "style--style"
    }}>{`style : `}<inlineCode parentName="h2">{`Style`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clientleft" id="element-clientleft"></a>
    <h2 {...{
      "id": "clientleft--number"
    }}>{`clientLeft : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clienttop" id="element-clienttop"></a>
    <h2 {...{
      "id": "clienttop--number"
    }}>{`clientTop : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clientwidth" id="element-clientwidth"></a>
    <h2 {...{
      "id": "clientwidth--number"
    }}>{`clientWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-clientheight" id="element-clientheight"></a>
    <h2 {...{
      "id": "clientheight--number"
    }}>{`clientHeight : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-height" id="element-height"></a>
    <h2 {...{
      "id": "height--string--number"
    }}>{`height : `}<inlineCode parentName="h2">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`Number`}</inlineCode></h2>
    <p>{`The height of the element`}</p>
    <a name="element-width" id="element-width"></a>
    <h2 {...{
      "id": "width--string--number"
    }}>{`width : `}<inlineCode parentName="h2">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`Number`}</inlineCode></h2>
    <p>{`The width of the element`}</p>
    <a name="element-offsetparent" id="element-offsetparent"></a>
    <h2 {...{
      "id": "offsetparent--element"
    }}>{`offsetParent : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsetleft" id="element-offsetleft"></a>
    <h2 {...{
      "id": "offsetleft--number"
    }}>{`offsetLeft : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsettop" id="element-offsettop"></a>
    <h2 {...{
      "id": "offsettop--number"
    }}>{`offsetTop : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsetwidth" id="element-offsetwidth"></a>
    <h2 {...{
      "id": "offsetwidth--number"
    }}>{`offsetWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-offsetheight" id="element-offsetheight"></a>
    <h2 {...{
      "id": "offsetheight--number"
    }}>{`offsetHeight : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-scrollleft" id="element-scrollleft"></a>
    <h2 {...{
      "id": "scrollleft--number"
    }}>{`scrollLeft : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <a name="element-scrolltop" id="element-scrolltop"></a>
    <h2 {...{
      "id": "scrolltop--number"
    }}>{`scrollTop : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <a name="element-scrollwidth" id="element-scrollwidth"></a>
    <h2 {...{
      "id": "scrollwidth--number"
    }}>{`scrollWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-scrollheight" id="element-scrollheight"></a>
    <h2 {...{
      "id": "scrollheight--number"
    }}>{`scrollHeight : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-autofocus" id="element-autofocus"></a>
    <h2 {...{
      "id": "autofocus--boolean"
    }}>{`autofocus : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates if the element will focus automatically when it is loaded`}</p>
    <a name="element-uxpcontainer" id="element-uxpcontainer"></a>
    <h2 {...{
      "id": "uxpcontainer--number"
    }}>{`uxpContainer : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="element-disabled" id="element-disabled"></a>
    <h2 {...{
      "id": "disabled--boolean"
    }}>{`disabled : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <a name="element-innerhtml" id="element-innerhtml"></a>
    <h2 {...{
      "id": "innerhtml--string"
    }}>{`innerHTML : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="element-outerhtml" id="element-outerhtml"></a>
    <h2 {...{
      "id": "outerhtml--string"
    }}>{`outerHTML : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="node-contenteditable" id="node-contenteditable"></a>
    <h2 {...{
      "id": "contenteditable"
    }}>{`contentEditable`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-isconnected" id="node-isconnected"></a>
    <h2 {...{
      "id": "isconnected--boolean"
    }}>{`isConnected : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-parentnode" id="node-parentnode"></a>
    <h2 {...{
      "id": "parentnode--node"
    }}>{`parentNode : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-parentelement" id="node-parentelement"></a>
    <h2 {...{
      "id": "parentelement--element"
    }}>{`parentElement : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-firstchild" id="node-firstchild"></a>
    <h2 {...{
      "id": "firstchild--node"
    }}>{`firstChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-lastchild" id="node-lastchild"></a>
    <h2 {...{
      "id": "lastchild--node"
    }}>{`lastChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-previoussibling" id="node-previoussibling"></a>
    <h2 {...{
      "id": "previoussibling--node"
    }}>{`previousSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-nextsibling" id="node-nextsibling"></a>
    <h2 {...{
      "id": "nextsibling--node"
    }}>{`nextSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-firstelementchild" id="node-firstelementchild"></a>
    <h2 {...{
      "id": "firstelementchild--node"
    }}>{`firstElementChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-lastelementchild" id="node-lastelementchild"></a>
    <h2 {...{
      "id": "lastelementchild--node"
    }}>{`lastElementChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-previouselementsibling" id="node-previouselementsibling"></a>
    <h2 {...{
      "id": "previouselementsibling--node"
    }}>{`previousElementSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-nextelementsibling" id="node-nextelementsibling"></a>
    <h2 {...{
      "id": "nextelementsibling--node"
    }}>{`nextElementSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-textcontent" id="node-textcontent"></a>
    <h2 {...{
      "id": "textcontent--string"
    }}>{`textContent : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="node-childnodes" id="node-childnodes"></a>
    <h2 {...{
      "id": "childnodes--nodelist"
    }}>{`childNodes : `}<inlineCode parentName="h2">{`NodeList`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-children" id="node-children"></a>
    <h2 {...{
      "id": "children--htmlcollection"
    }}>{`children : `}<inlineCode parentName="h2">{`HTMLCollection`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-ownerdocument" id="node-ownerdocument"></a>
    <h2 {...{
      "id": "ownerdocument"
    }}>{`ownerDocument`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="htmldialogelement-show" id="htmldialogelement-show"></a>
    <h2 {...{
      "id": "showoptions"
    }}>{`show(`}{`[options]`}{`)`}</h2>
    <p>{`Show the non modal dialog.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Options for the show.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.anchorOffset]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Offset from the anchor for the initial positioning of the dialog.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.anchorOffset.top]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Top offset from the anchor for the initial positioning of the dialog.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.anchorOffset.left]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Left offset from the anchor for the initial positioning of the dialog.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="htmldialogelement-showmodal" id="htmldialogelement-showmodal"></a>
    <h2 {...{
      "id": "showmodal"
    }}>{`showModal()`}</h2>
    <p>{`Show the modal dialog.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise`}</inlineCode>{` - A promise that resolves when the dialog is closed (`}<strong parentName="p">{`NSC`}</strong>{`)
after calling the close() method or clicking the "submit" button.
The promise will be resolved with returnValue as a parameter.
The promise can be rejected if the dialog was closed for other reasons
e.g. the user hit escape or closed the window, or if the application
does not allow showing the dialog. The error parameter will give more details.
error.code will be one of the values from HTMLDialogElement.rejectionReasons.  `}</p>
    <a name="htmldialogelement-close" id="htmldialogelement-close"></a>
    <h2 {...{
      "id": "closereturnvalue"
    }}>{`close(`}{`[returnValue]`}{`)`}</h2>
    <p>{`Closes the dialog; setting the return value (optional)`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[returnValue]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-scrollto" id="element-scrollto"></a>
    <h2 {...{
      "id": "scrolltoxoroptions-y"
    }}>{`scrollTo(xOrOptions, y)`}</h2>
    <p>{`Scrolls the element to the new x and y positions. If options object is used with behavior: "smooth" then the element is smoothly scrolled.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xOrOptions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`either the new scrollLeft position or an options object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the optional new scrollTop position.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="element-scrollintoview" id="element-scrollintoview"></a>
    <h2 {...{
      "id": "scrollintoviewaligntotop"
    }}>{`scrollIntoView(alignToTop)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`alignToTop`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-scrollintoviewifneeded" id="element-scrollintoviewifneeded"></a>
    <h2 {...{
      "id": "scrollintoviewifneeded"
    }}>{`scrollIntoViewIfNeeded()`}</h2>
    <a name="element-focus" id="element-focus"></a>
    <h2 {...{
      "id": "focus"
    }}>{`focus()`}</h2>
    <a name="element-blur" id="element-blur"></a>
    <h2 {...{
      "id": "blur"
    }}>{`blur()`}</h2>
    <a name="element-getattribute" id="element-getattribute"></a>
    <h2 {...{
      "id": "getattributename"
    }}>{`getAttribute(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-setattribute" id="element-setattribute"></a>
    <h2 {...{
      "id": "setattributename-value"
    }}>{`setAttribute(name, value)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-removeattribute" id="element-removeattribute"></a>
    <h2 {...{
      "id": "removeattributename"
    }}>{`removeAttribute(name)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-hasattribute" id="element-hasattribute"></a>
    <h2 {...{
      "id": "hasattributename"
    }}>{`hasAttribute(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-getattributenode" id="element-getattributenode"></a>
    <h2 {...{
      "id": "getattributenodename"
    }}>{`getAttributeNode(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`*`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-setattributenode" id="element-setattributenode"></a>
    <h2 {...{
      "id": "setattributenodenewattr"
    }}>{`setAttributeNode(newAttr)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newAttr`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-removeattributenode" id="element-removeattributenode"></a>
    <h2 {...{
      "id": "removeattributenodeoldattr"
    }}>{`removeAttributeNode(oldAttr)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`oldAttr`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-click" id="element-click"></a>
    <h2 {...{
      "id": "click"
    }}>{`click()`}</h2>
    <a name="element-getelementsbyclassname" id="element-getelementsbyclassname"></a>
    <h2 {...{
      "id": "getelementsbyclassnamename"
    }}>{`getElementsByClassName(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`NodeList`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-getelementsbytagname" id="element-getelementsbytagname"></a>
    <h2 {...{
      "id": "getelementsbytagnamename"
    }}>{`getElementsByTagName(name)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`NodeList`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-queryselector" id="element-queryselector"></a>
    <h2 {...{
      "id": "queryselectorselector"
    }}>{`querySelector(selector)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Element`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selector`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-queryselectorall" id="element-queryselectorall"></a>
    <h2 {...{
      "id": "queryselectorallselector"
    }}>{`querySelectorAll(selector)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`NodeList`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selector`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-getboundingclientrect" id="element-getboundingclientrect"></a>
    <h2 {...{
      "id": "getboundingclientrect"
    }}>{`getBoundingClientRect()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`*`}</inlineCode>{`  `}</p>
    <a name="element-closest" id="element-closest"></a>
    <h2 {...{
      "id": "closestselectorstring"
    }}>{`closest(selectorString)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Element`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/closest"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/closest`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selectorString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-matches" id="element-matches"></a>
    <h2 {...{
      "id": "matchesselectorstring"
    }}>{`matches(selectorString)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/matches"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Element/matches`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selectorString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-insertadjacenthtml" id="element-insertadjacenthtml"></a>
    <h2 {...{
      "id": "insertadjacenthtmlposition-value"
    }}>{`insertAdjacentHTML(position, value)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-insertadjacentelement" id="element-insertadjacentelement"></a>
    <h2 {...{
      "id": "insertadjacentelementposition-node"
    }}>{`insertAdjacentElement(position, node)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="element-insertadjacenttext" id="element-insertadjacenttext"></a>
    <h2 {...{
      "id": "insertadjacenttextposition-text"
    }}>{`insertAdjacentText(position, text)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-haschildnodes" id="node-haschildnodes"></a>
    <h2 {...{
      "id": "haschildnodes"
    }}>{`hasChildNodes()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="node-clonenode" id="node-clonenode"></a>
    <h2 {...{
      "id": "clonenodedeep"
    }}>{`cloneNode(deep)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`deep`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-appendchild" id="node-appendchild"></a>
    <h2 {...{
      "id": "appendchildchild"
    }}>{`appendChild(child)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-insertbefore" id="node-insertbefore"></a>
    <h2 {...{
      "id": "insertbeforechild-before"
    }}>{`insertBefore(child, before)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`before`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-replacechild" id="node-replacechild"></a>
    <h2 {...{
      "id": "replacechildnewchild-oldchild"
    }}>{`replaceChild(newChild, oldChild)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`oldChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-removechild" id="node-removechild"></a>
    <h2 {...{
      "id": "removechildchild"
    }}>{`removeChild(child)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-remove" id="node-remove"></a>
    <h2 {...{
      "id": "remove"
    }}>{`remove()`}</h2>
    <a name="node-before" id="node-before"></a>
    <h2 {...{
      "id": "beforenodes"
    }}>{`before(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-after" id="node-after"></a>
    <h2 {...{
      "id": "afternodes"
    }}>{`after(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-replacewith" id="node-replacewith"></a>
    <h2 {...{
      "id": "replacewithnodes"
    }}>{`replaceWith(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-contains" id="node-contains"></a>
    <h2 {...{
      "id": "containsnode"
    }}>{`contains(node)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-addeventlistener" id="eventtarget-addeventlistener"></a>
    <h2 {...{
      "id": "addeventlistenereventname-callback-capture"
    }}>{`addEventListener(eventName, callback, `}{`[capture]`}{`)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[capture]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-removeeventlistener" id="eventtarget-removeeventlistener"></a>
    <h2 {...{
      "id": "removeeventlistenereventname-callback-capture"
    }}>{`removeEventListener(eventName, callback, `}{`[capture]`}{`)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[capture]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-dispatchevent" id="eventtarget-dispatchevent"></a>
    <h2 {...{
      "id": "dispatcheventevent"
    }}>{`dispatchEvent(event)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`event`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      